export default __webpack_public_path__ + "7568ba64adfc4384e0992121fb3c03cb.png";